// extracted by mini-css-extract-plugin
export default {"workerCard":"styles_workerCard__D6Psd","selected":"styles_selected__G2o0W","tagNick":"styles_tagNick__cUP0O","tagName":"styles_tagName__sK6my"};